import React from "react";

type CarregandoProps = {
  exibir: boolean;
  concluido: boolean;
};

class Carregando extends React.Component<CarregandoProps, {}> {
  render (): any {
    const { exibir, concluido } = this.props;

    return (
      <>
      <div className={ `loader ${ !exibir ? "hide" : "" }` }>
        <div className="holder">
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          <span>Carregando ...</span>
        </div>
      </div>
      { concluido && 
      <div className={ `loaded` }>
      </div>
      }
      </>
    );
  }
}

export default Carregando;